import { Action } from '@ngrx/store';

export enum ActionTypes {

    LOAD_CLIENT_CONSULTANTS = '[Features] load Consultants Action',
    LOAD_CLIENT_CONSULTANTS_SUCCESS = '[Features] load Consultants Success Action',
    LOAD_CLIENT_CONSULTANTS_FAILED = '[Features] load Consultants Failed Action'
}

export class LoadClientConsultantAction implements Action {
    readonly type = ActionTypes.LOAD_CLIENT_CONSULTANTS;
    public constructor(public payload: any) {
    }
}

export class LoadClientConsultantSuccessAction implements Action {
    readonly type = ActionTypes.LOAD_CLIENT_CONSULTANTS_SUCCESS;
    public constructor(public payload: any) {
    }
}

export class LoadClientConsultantFailedAction implements Action {
    readonly type = ActionTypes.LOAD_CLIENT_CONSULTANTS_FAILED;
    public constructor(public payload: any) {
    }
}


export type Actions =
    LoadClientConsultantAction |
    LoadClientConsultantSuccessAction |
    LoadClientConsultantFailedAction;
